import createIcon from '../../createIcon';

/**
 * @component @name Sanitizer
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQuNSA2LjVDMTQuNSA1LjY2IDE2IDQgMTYgNEMxNiA0IDE3LjUgNS42NiAxNy41IDYuNUMxNy41IDcuMzMgMTYuODMgOCAxNiA4QzE1LjE3IDggMTQuNSA3LjMzIDE0LjUgNi41Wk0xOC41IDE1QzE5Ljg4IDE1IDIxIDEzLjg4IDIxIDEyLjVDMjEgMTAuODMgMTguNSA4IDE4LjUgOEMxOC41IDggMTYgMTAuODMgMTYgMTIuNUMxNiAxMy44OCAxNy4xMiAxNSAxOC41IDE1Wk0xMiAxNEgxMFYxMkg4VjE0SDZWMTZIOFYxOEgxMFYxNkgxMlYxNFpNMTUgMTJWMjJIM1YxMkMzIDkuMDMgNS4xNiA2LjU3IDggNi4wOVY0SDZWMkgxMkMxMy4xMyAyIDE0LjE1IDIuMzkgMTQuOTkgMy4wMUwxMy41NiA0LjQ0QzEzLjEgNC4xNyAxMi41NyA0IDEyIDRIMTBWNi4wOUMxMi44NCA2LjU3IDE1IDkuMDMgMTUgMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sanitizer = createIcon('Sanitizer', [
  [
    'path',
    {
      d: 'M14.5 6.5C14.5 5.66 16 4 16 4C16 4 17.5 5.66 17.5 6.5C17.5 7.33 16.83 8 16 8C15.17 8 14.5 7.33 14.5 6.5ZM18.5 15C19.88 15 21 13.88 21 12.5C21 10.83 18.5 8 18.5 8C18.5 8 16 10.83 16 12.5C16 13.88 17.12 15 18.5 15ZM12 14H10V12H8V14H6V16H8V18H10V16H12V14ZM15 12V22H3V12C3 9.03 5.16 6.57 8 6.09V4H6V2H12C13.13 2 14.15 2.39 14.99 3.01L13.56 4.44C13.1 4.17 12.57 4 12 4H10V6.09C12.84 6.57 15 9.03 15 12Z',
      key: '1csem3',
    },
  ],
]);

export default Sanitizer;
